import HttpClient from "./http-client";
import ITronLogo, { ITronLogoEventData } from "./tron-logo";
import { getApiUrl } from "./common";

export class FileUploader {
    private fileInput: Element;
    private url: string;
    private onSuccess: () => void;

    constructor(fileInput: Element, url: string, onSuccess: () => void = null) {
        this.fileInput = fileInput;
        this.url = url;
        this.onSuccess = onSuccess;
        this.init();
    }

    private async upload(event: Event): Promise<void> {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        const formData = new FormData();
        formData.append('file', files[0]);

        const response = await new HttpClient().fetch(this.url, {
            method: 'POST',
            body: formData
        });

        if(response.ok) {
            this.onSuccess && this.onSuccess();
        }
    }

    private init(): void {
        this.fileInput.addEventListener(
            'change',
            async event => await this.upload(event)
        );
    }
}

export class TronLogoFileUploader {
    private tronLogoInitAttemptCount = 0; 
    private onSuccess: () => void;
    
    constructor(onSuccess: () => void){
        this.onSuccess = onSuccess;
        this.init();
    }

    private init(){
        this.addTronLogoListener();
    }

    private addTronLogoListener() {
        const tronLogo = window.tronlogo as ITronLogo
        if (tronLogo) {     
            tronLogo.registerForTronLogoEvents((eventData) => this.tronLogoEventHandler(eventData));
            return;
        }
        this.tronLogoInitAttemptCount += 1;       
        if (this.tronLogoInitAttemptCount < 10) {
             window.setTimeout(this.addTronLogoListener, 200);
        }
    }
    
    private async tronLogoEventHandler(eventData: ITronLogoEventData): Promise<void> {
        if(eventData.type === 'UPLOADDONE' || eventData.type == 'MOTIVECHANGE'){
            console.log(`Tron Logo upload done. Image guid: ${eventData.motiveId}, cart item id: ${eventData.custom1}`);
            const url = `${getApiUrl()}/cart/${eventData.custom1}/file/tronlogo/${eventData.motiveId}`;

            const response = await new HttpClient().fetch(url, {
                method: 'POST'
            });

            response.ok && this.onSuccess && this.onSuccess();
        }
    }

}
